import * as stylex from '@stylexjs/stylex';
import { MdRocketLaunch } from 'react-icons/md';
import { styles } from './styles';
let dialog: HTMLDialogElement | null = null;
export function openComingSoon() {
  dialog?.showModal();
}

// Native <dialog>, mounted once in App. Every get-the-app action opens this
// until the store listings exist.
export function ComingSoonDialog() {
  return <dialog ref={el => {
    dialog = el;
  }} {...stylex.props(styles.dialog)} onClick={e => {
    if (e.target === e.currentTarget) dialog?.close();
  }}>
      <MdRocketLaunch size={36} {...stylex.props(styles.icon)} />
      <h2 {...stylex.props(styles.title)}>Coming soon</h2>
      <p {...stylex.props(styles.text)}>
        Tribys is in its final stretch before launch. The app isn&apos;t in
        the stores just yet — check back soon.
      </p>
      <button type="button" {...stylex.props(styles.ok)} onClick={() => dialog?.close()}>
        Can&apos;t wait
      </button>
    </dialog>;
}